// -------------- Hook to call the api endpoint for the macro data ------------------
// ----------------------------------------------------------------------------------
// import react libraries and api service functions
import { useState, useEffect } from 'react';
import { getMacroHistory } from '../services/api';

// hook to fetch historical macroeconomic data based on the specified indicator and timeframe
export const useMacroHistory = (indicator, timeframe) => {

  // set the state variables for the historical data and loading state
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { // fetch historical data when the indicator or timeframe changes
    if (!indicator) {
      setHistoryData([]);
      return;
    }

    let cancelled = false; // flag to prevent update when mounted
    setLoading(true);

    getMacroHistory(indicator, timeframe) // call the api service to get the data
      .then((response) => {
        if (!cancelled) setHistoryData(response.data || []); // update the state with the fetched data or an empty array if no data is returned
      })
      .catch(() => { if (!cancelled) setHistoryData([]); }) // catch any errors
      .finally(() => { if (!cancelled) setLoading(false); }); // set loading to false after the fetch is complete

    return () => { cancelled = true; };

  }, [indicator, timeframe]);

  return { historyData, loading };
};
